export default __webpack_public_path__ + "static/media/phone.68278a72.svg";